import "nprogress/nprogress.css" // You can customize this CSS file

import NProgress from "nprogress"
import { useEffect } from "react"
import { useLocation, useNavigation } from "react-router"

import { sleep } from "~/utils/sleep"

const ProgressBar = () => {
  const navigation = useNavigation()
  const { hash } = useLocation()

  useEffect(() => {
    NProgress.configure({
      showSpinner: false
    })
    if (navigation.state === "loading") {
      NProgress.start()
    } else {
      NProgress.done()
    }
  }, [navigation.state])

  useEffect(() => {
    if (navigation.state === "loading" && hash) return
    NProgress.start()
    const { promise, clear } = sleep(300)
    promise.then(() => {
      NProgress.done()
    })
    return () => {
      clear()
    }
  }, [hash, navigation.state])

  return null
}

export default ProgressBar
